import { LocalizedText } from '@/src/types/hotels/itinerary'

// Pick the active locale's text, falling back to English (RN parity). Shared by the
// review and itinerary transforms so the fallback rule lives in one place.
export const localized = (text: LocalizedText | undefined, locale: string): string => {
    if (!text) return ''
    return (locale === 'ar' ? text.ar : text.en) || text.en || ''
}
